import styled from "@emotion/styled";

export const Root = styled("div")<{ width?: number }>(props => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#757575",
    margin: "75px auto 50px auto",
    maxWidth: props.width ?? "600px",
}));

export const IconBlock = styled("div")({
    marginBottom: "12px",
});

export const Title = styled("h4")({
    margin: "2px 0 8px 0",
    fontSize: "16px",
    fontWeight: 700,
});

export const Description = styled("p")({
    margin: "2px 0 10px 0",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 400,
});

export const Children = styled("div")({
    margin: "4px 0 14px",
});
